import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=660a80db&scoped=true&lang=pug&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=660a80db&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a80db",
  null
  
)

export default component.exports